<template>
  <div>
    <div v-for="(item, index) in items" :key="`progress-history-item-${index}`">
      <custom-callout
        :ref="`callout-${index}`"
        :controlled="true"
        class="w-100 mt-3"
        :has-border="false"
        :opened="item.isOpen"
        @click:open="openDetail(index)"
      >
        <div class="row">
          <div
            class="col color-dark-gray font-weight-bold font-16 d-flex align-items-center"
          >
            {{ item.ipSequenceName }}
          </div>
          <div
            class="col color-black font-16 d-flex justify-content-center align-items-center"
          >
            {{ item.date }}
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <dropdown
              v-if="showActions(item)"
              icon="fas fa-print"
              :data-item="{ item, index }"
              :items="actionItems(item)"
              title="Imprimir"
              class="mr-2"
            />
            <action-button
              v-if="isLastRecord(index) && !item.isClosed"
              i="fas fa-lock-open"
              variant="success outline-success mr-2 pr-1"
              @click="$emit('on-close-ip', item)"
            />
            <action-button
              v-if="isLastRecord(index) && !item.isClosed"
              i="fas fa-sync-alt"
              variant="success outline-success mr-2 pr-1"
              @click="$emit('on-update-ip', item)"
            />
          </div>
        </div>
        <template #edition>
          <div class="mt-1 bg-secondary-3 rounded">
            <progress-info-summary :items="item.summary" />
          </div>
        </template>
      </custom-callout>
      <div class="row">
        <div class="col color-dark-gray font-weight-bold font-16 d-flex align-items-center">
          <queue-report-status 
            :queue-report="item.detailIpReport"
            @on-download="onDownloadHandler"
            @on-cancel="onCancelHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import Dropdown from "dropdown";
import ActionButton from "ActionButton";
import ProgressInfoSummary from "./ProgressInfoSummary";
import QueueReportStatus from './QueueReportStatus.vue';
import queueStatus from '@/utils/constants/queueReportStatus.js';

export default {
  name: "ProgressInfoHistory",
  components: {
    CustomCallout,
    Dropdown,
    ActionButton,
    ProgressInfoSummary,
    QueueReportStatus,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    actionItems: {
      type: Function,
      default: () => {},
    }
  },
  computed: {
    isLastRecord() {
      return (index) => index === 0;
    },
    showActions() {
      return (item) => {
        return !([queueStatus.Pending, queueStatus.Running]
          .includes(item.detailIpReport?.statusId ?? 0));
      };
    },
  },
  methods: {
    openDetail(index) {
      this.$emit('on-open-detail', index);
    },
    onDownloadHandler(executionLogId) {
      this.$emit('on-download', executionLogId);
    },
    onCancelHandler(executionLogId) {
      this.$emit('on-cancel', executionLogId);
    },
  },
};
</script>
